<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 500 500"
    [attr.width]="size" [attr.height]="size" [ngClass]="{'bl-display--block bl-margin-x--auto': alignCenter}">
    <defs>
        <linearGradient id="loadingGradient">
            <stop offset="0%" stop-color="blue" opacity="1" />
            <stop offset="50%" stop-color="lightblue" opacity="1">
                <animate attributeName="offset" values="0;1;0" dur="2s" repeatCount="indefinite" />
            </stop>
            <stop offset="100%" stop-color="blue" opacity="1" />
        </linearGradient>
    </defs>

    <g>
        <!-- Document -->
        <g transform="translate(-50, -50)">
            <g transform="translate(118, 86)">
                <g transform="translate(-118, -86)">
                    <g transform="translate(299.9, 304.75)">
                        <path class="application-path" />
                    </g>
                </g>
            </g>
            <g>
                <g transform="translate(299.8, 241.8) scale(0.55)">
                    <!-- Top Card -->
                    <g transform="translate(500.3, 500.6)">
                        <g transform="translate(-500.3, -504.1)">
                            <path class="card-path" />
                        </g>
                        <!-- Card 1 Lines -->
                        <rect class="lines-loader" width="80" height="6" rx="2" x="-620" y="-530" />
                        <rect class="lines-loader" width="80" height="6" rx="2" x="-620" y="-510" />
                        <rect class="lines-loader" width="80" height="6" rx="2" x="-620" y="-490" />
                        <rect class="lines-loader" width="80" height="6" rx="2" x="-620" y="-470" />
                        <rect class="lines-loader" width="80" height="6" rx="2" x="-620" y="-450" />

                        <rect class="lines-loader" width="80" height="6" rx="2" x="-500" y="-530" />
                        <rect class="lines-loader" width="80" height="6" rx="2" x="-500" y="-510" />
                        <rect class="lines-loader" width="80" height="6" rx="2" x="-500" y="-490" />
                        <rect class="lines-loader" width="80" height="6" rx="2" x="-500" y="-470" />
                        <rect class="lines-loader" width="80" height="6" rx="2" x="-500" y="-450" />

                        <g transform="translate(-397, -559)">
                            <path class="card-button-border-path" />
                        </g>
                        <g transform="translate(-397.2, -559)">
                            <path class="card-button-line-path" />
                        </g>
                        <g transform="translate(-392.2, -159.5)">
                            <path class="application-button-path" />
                        </g>
                        <g transform="translate(-582.8, -560.7)">
                            <path class="card-heading-path" />
                        </g>
                    </g>
                    <!-- Bottom Card -->
                    <g transform="translate(501, 618.7)">
                        <g transform="translate(-500.3, -402.2)">
                            <path class="card-path" />
                        </g>
                        <rect class="lines-loader" width="80" height="6" rx="2" x="-620" y="-425" />
                        <rect class="lines-loader" width="80" height="6" rx="2" x="-620" y="-405" />
                        <rect class="lines-loader" width="80" height="6" rx="2" x="-620" y="-385" />
                        <rect class="lines-loader" width="80" height="6" rx="2" x="-620" y="-365" />
                        <rect class="lines-loader" width="80" height="6" rx="2" x="-620" y="-345" />

                        <rect class="lines-loader" width="80" height="6" rx="2" x="-500" y="-425" />
                        <rect class="lines-loader" width="80" height="6" rx="2" x="-500" y="-405" />
                        <rect class="lines-loader" width="80" height="6" rx="2" x="-500" y="-385" />
                        <rect class="lines-loader" width="80" height="6" rx="2" x="-500" y="-365" />
                        <rect class="lines-loader" width="80" height="6" rx="2" x="-500" y="-345" />

                        <g transform="translate(-397.3, -457.3)">
                            <path class="card-button-border-path" />
                        </g>
                        <g transform="translate(-397.2, -457.1)">
                            <path class="card-button-line-path" />
                        </g>
                        <g transform="translate(-583.3, -456.5)">
                            <path class="card-heading-path" />
                        </g>
                    </g>
                </g>
            </g>
        </g>

        <g transform="matrix(0.4,0,0,0.4,250,200)">
            <path class="check-loader" />
        </g>

    </g>
</svg>